import { useEffect } from 'react';

const useUpdateWrapperMinWidthStyleForPolicy = (open: boolean) => {
  useEffect(() => {
    if (open) {
      const searchParams = new URLSearchParams(window.location.search);
      const componentWrapper = document.querySelector('.component-wrapper');
      if (componentWrapper instanceof HTMLElement) {
        const componentWrapperContent = document.querySelector('.component-wrapper-content') as HTMLElement;
        const mediaQuery = window.matchMedia('(min-width: 721px)');
        if (mediaQuery.matches) {
          componentWrapper.style.minWidth = 'inherit';
        }
        if (searchParams.get('layout') && searchParams.get('layout') === 'no') {
          componentWrapperContent.style.marginTop = '0px';
        }
      }
    }
  }, [open]);
};

export default useUpdateWrapperMinWidthStyleForPolicy;
